import HasToBeClientGuard from 'app/core/guards/HasToBeClientGuard';
import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

import { HasToBeLoggedInGuard } from '../../../guards/HasToBeLoggedInGuard';

const StepsLayout = lazy(
  () => import('../../../../main/elevators/steps/layout/StepsLayout')
);
const CreateNewProject = lazy(
  () => import('../../../../main/elevators/create-new-project/CreateNewProject')
);

const Step1 = lazy(
  () => import('../../../../main/elevators/steps/step1/Step1')
);

const Step2 = lazy(
  () => import('../../../../main/elevators/steps/step2/Step2')
);

const ProjectSummary = lazy(
  () =>
    import('../../../../main/elevators/steps/project-summary/ProjectSummary')
);

const Projects = lazy(
  () => import('../../../../main/elevators/projects/Projects')
);

const Certificates = lazy(
  () => import('../../../../main/elevators/certificates/Certificates')
);

const Inspections = lazy(
  () => import('../../../../main/elevators/inspections/Inspections')
);

const Invitations = lazy(
  () => import('../../../../main/elevators/invitations/Invitations')
);

const ProjectDetails = lazy(
  () =>
    import('../../../../main/elevators/projects/project-details/ProjectDetails')
);

const EquipmentDetails = lazy(
  () =>
    import(
      '../../../../main/elevators/projects/equipment-details/EquipmentDetails'
    )
);

const ReportDetails = lazy(
  () => import('../../../../main/elevators/report-details/ReportDetails')
);

const PaymentRequestPay = lazy(
  () =>
    import(
      '../../../../main/elevators/payments/inspections-payment/InspectionsPayment'
    )
);

const PaymentRequestReceipt = lazy(
  () =>
    import(
      '../../../../main/elevators/payments/inspections-payment-receipt/InspectionsPaymentReceipt'
    )
);
const CertificatesPaymentCreate = lazy(
  () =>
    import(
      '../../../../main/elevators/payments/certificate-payment/CertificatesPaymentCreate'
    )
);

const CertificatePay = lazy(
  () =>
    import(
      '../../../../main/elevators/payments/certificate-payment/CertificatesPayment'
    )
);

const PREFIX = '/elevators/';

export const clientElevatorsRoutes: Array<RouteConfig> = [
  {
    path: PREFIX + 'create-project',
    component: () => (
      <StepsLayout>
        <CreateNewProject />
      </StepsLayout>
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/step/1',
    component: () => (
      <StepsLayout>
        <Step1 />
      </StepsLayout>
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/step/2',
    component: () => (
      <StepsLayout>
        <Step2 />
      </StepsLayout>
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/step/3',
    component: () => (
      <StepsLayout>
        <ProjectSummary />
      </StepsLayout>
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id',
    exact: true,
    component: () => <ProjectDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'equipment/:equipmentId',
    exact: true,
    component: () => <EquipmentDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects',
    exact: true,
    component: () => <Projects />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'certificates',
    exact: true,
    component: () => <Certificates />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'inspections',
    exact: true,
    component: () => <Inspections />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'invitations',
    exact: true,
    component: () => <Invitations />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'report/:id',
    exact: true,
    component: () => <ReportDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/payment-request/:paymentRequestId',
    exact: true,
    component: () => <PaymentRequestPay />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/payment-request/:paymentRequestId/receipt',
    exact: true,
    component: () => <PaymentRequestReceipt />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/certificates-payment',
    exact: true,
    component: () => <CertificatesPaymentCreate />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
  {
    path: PREFIX + 'projects/:id/certificates-payment/:paymentRequestId',
    exact: true,
    component: () => <CertificatePay />,
    canActivate: [HasToBeLoggedInGuard, HasToBeClientGuard],
  },
];
